import { Box } from '@chakra-ui/react';
import React from 'react';
import { useCQMediaQuery } from '@laxmimanogna/code-quick-components';

const CQContainer = props => {
  const marginHorizontal = useCQMediaQuery({
    lg: '10%',
    md: '4%',
    sm: '2%',
  });

  return (
    <Box 
    py={30} px={0} mx={marginHorizontal} {...props} />
  );
};

CQContainer.propTypes = {
  ...Box.propTypes,
};

export default CQContainer;
